/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as CopilotsImport } from './routes/copilots'
import { Route as AboutImport } from './routes/about'
import { Route as SettingsRouteImport } from './routes/settings/route'
import { Route as DevRouteImport } from './routes/dev/route'
import { Route as IndexImport } from './routes/index'
import { Route as SettingsIndexImport } from './routes/settings/index'
import { Route as DevIndexImport } from './routes/dev/index'
import { Route as SettingsWebSearchImport } from './routes/settings/web-search'
import { Route as SettingsMcpImport } from './routes/settings/mcp'
import { Route as SettingsKnowledgeBaseImport } from './routes/settings/knowledge-base'
import { Route as SettingsHotkeysImport } from './routes/settings/hotkeys'
import { Route as SettingsGeneralImport } from './routes/settings/general'
import { Route as SettingsDefaultModelsImport } from './routes/settings/default-models'
import { Route as SettingsChatImport } from './routes/settings/chat'
import { Route as SessionSessionIdImport } from './routes/session/$sessionId'
import { Route as DevStorageImport } from './routes/dev/storage'
import { Route as DevModelSelectorImport } from './routes/dev/model-selector'
import { Route as SettingsProviderRouteImport } from './routes/settings/provider/route'
import { Route as SettingsProviderIndexImport } from './routes/settings/provider/index'
import { Route as SettingsProviderChatboxAiImport } from './routes/settings/provider/chatbox-ai'
import { Route as SettingsProviderProviderIdImport } from './routes/settings/provider/$providerId'

// Create/Update Routes

const CopilotsRoute = CopilotsImport.update({
  id: '/copilots',
  path: '/copilots',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRouteRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const DevRouteRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsIndexRoute = SettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const DevIndexRoute = DevIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevRouteRoute,
} as any)

const SettingsWebSearchRoute = SettingsWebSearchImport.update({
  id: '/web-search',
  path: '/web-search',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsMcpRoute = SettingsMcpImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsKnowledgeBaseRoute = SettingsKnowledgeBaseImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsHotkeysRoute = SettingsHotkeysImport.update({
  id: '/hotkeys',
  path: '/hotkeys',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsGeneralRoute = SettingsGeneralImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsDefaultModelsRoute = SettingsDefaultModelsImport.update({
  id: '/default-models',
  path: '/default-models',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsChatRoute = SettingsChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SessionSessionIdRoute = SessionSessionIdImport.update({
  id: '/session/$sessionId',
  path: '/session/$sessionId',
  getParentRoute: () => rootRoute,
} as any)

const DevStorageRoute = DevStorageImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => DevRouteRoute,
} as any)

const DevModelSelectorRoute = DevModelSelectorImport.update({
  id: '/model-selector',
  path: '/model-selector',
  getParentRoute: () => DevRouteRoute,
} as any)

const SettingsProviderRouteRoute = SettingsProviderRouteImport.update({
  id: '/provider',
  path: '/provider',
  getParentRoute: () => SettingsRouteRoute,
} as any)

const SettingsProviderIndexRoute = SettingsProviderIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsProviderRouteRoute,
} as any)

const SettingsProviderChatboxAiRoute = SettingsProviderChatboxAiImport.update({
  id: '/chatbox-ai',
  path: '/chatbox-ai',
  getParentRoute: () => SettingsProviderRouteRoute,
} as any)

const SettingsProviderProviderIdRoute = SettingsProviderProviderIdImport.update(
  {
    id: '/$providerId',
    path: '/$providerId',
    getParentRoute: () => SettingsProviderRouteRoute,
  } as any,
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/copilots': {
      id: '/copilots'
      path: '/copilots'
      fullPath: '/copilots'
      preLoaderRoute: typeof CopilotsImport
      parentRoute: typeof rootRoute
    }
    '/settings/provider': {
      id: '/settings/provider'
      path: '/provider'
      fullPath: '/settings/provider'
      preLoaderRoute: typeof SettingsProviderRouteImport
      parentRoute: typeof SettingsRouteImport
    }
    '/dev/model-selector': {
      id: '/dev/model-selector'
      path: '/model-selector'
      fullPath: '/dev/model-selector'
      preLoaderRoute: typeof DevModelSelectorImport
      parentRoute: typeof DevRouteImport
    }
    '/dev/storage': {
      id: '/dev/storage'
      path: '/storage'
      fullPath: '/dev/storage'
      preLoaderRoute: typeof DevStorageImport
      parentRoute: typeof DevRouteImport
    }
    '/session/$sessionId': {
      id: '/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/session/$sessionId'
      preLoaderRoute: typeof SessionSessionIdImport
      parentRoute: typeof rootRoute
    }
    '/settings/chat': {
      id: '/settings/chat'
      path: '/chat'
      fullPath: '/settings/chat'
      preLoaderRoute: typeof SettingsChatImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/default-models': {
      id: '/settings/default-models'
      path: '/default-models'
      fullPath: '/settings/default-models'
      preLoaderRoute: typeof SettingsDefaultModelsImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/hotkeys': {
      id: '/settings/hotkeys'
      path: '/hotkeys'
      fullPath: '/settings/hotkeys'
      preLoaderRoute: typeof SettingsHotkeysImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/knowledge-base': {
      id: '/settings/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/settings/knowledge-base'
      preLoaderRoute: typeof SettingsKnowledgeBaseImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/mcp': {
      id: '/settings/mcp'
      path: '/mcp'
      fullPath: '/settings/mcp'
      preLoaderRoute: typeof SettingsMcpImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/web-search': {
      id: '/settings/web-search'
      path: '/web-search'
      fullPath: '/settings/web-search'
      preLoaderRoute: typeof SettingsWebSearchImport
      parentRoute: typeof SettingsRouteImport
    }
    '/dev/': {
      id: '/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexImport
      parentRoute: typeof DevRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexImport
      parentRoute: typeof SettingsRouteImport
    }
    '/settings/provider/$providerId': {
      id: '/settings/provider/$providerId'
      path: '/$providerId'
      fullPath: '/settings/provider/$providerId'
      preLoaderRoute: typeof SettingsProviderProviderIdImport
      parentRoute: typeof SettingsProviderRouteImport
    }
    '/settings/provider/chatbox-ai': {
      id: '/settings/provider/chatbox-ai'
      path: '/chatbox-ai'
      fullPath: '/settings/provider/chatbox-ai'
      preLoaderRoute: typeof SettingsProviderChatboxAiImport
      parentRoute: typeof SettingsProviderRouteImport
    }
    '/settings/provider/': {
      id: '/settings/provider/'
      path: '/'
      fullPath: '/settings/provider/'
      preLoaderRoute: typeof SettingsProviderIndexImport
      parentRoute: typeof SettingsProviderRouteImport
    }
  }
}

// Create and export the route tree

interface DevRouteRouteChildren {
  DevModelSelectorRoute: typeof DevModelSelectorRoute
  DevStorageRoute: typeof DevStorageRoute
  DevIndexRoute: typeof DevIndexRoute
}

const DevRouteRouteChildren: DevRouteRouteChildren = {
  DevModelSelectorRoute: DevModelSelectorRoute,
  DevStorageRoute: DevStorageRoute,
  DevIndexRoute: DevIndexRoute,
}

const DevRouteRouteWithChildren = DevRouteRoute._addFileChildren(
  DevRouteRouteChildren,
)

interface SettingsProviderRouteRouteChildren {
  SettingsProviderProviderIdRoute: typeof SettingsProviderProviderIdRoute
  SettingsProviderChatboxAiRoute: typeof SettingsProviderChatboxAiRoute
  SettingsProviderIndexRoute: typeof SettingsProviderIndexRoute
}

const SettingsProviderRouteRouteChildren: SettingsProviderRouteRouteChildren = {
  SettingsProviderProviderIdRoute: SettingsProviderProviderIdRoute,
  SettingsProviderChatboxAiRoute: SettingsProviderChatboxAiRoute,
  SettingsProviderIndexRoute: SettingsProviderIndexRoute,
}

const SettingsProviderRouteRouteWithChildren =
  SettingsProviderRouteRoute._addFileChildren(
    SettingsProviderRouteRouteChildren,
  )

interface SettingsRouteRouteChildren {
  SettingsProviderRouteRoute: typeof SettingsProviderRouteRouteWithChildren
  SettingsChatRoute: typeof SettingsChatRoute
  SettingsDefaultModelsRoute: typeof SettingsDefaultModelsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsHotkeysRoute: typeof SettingsHotkeysRoute
  SettingsKnowledgeBaseRoute: typeof SettingsKnowledgeBaseRoute
  SettingsMcpRoute: typeof SettingsMcpRoute
  SettingsWebSearchRoute: typeof SettingsWebSearchRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsProviderRouteRoute: SettingsProviderRouteRouteWithChildren,
  SettingsChatRoute: SettingsChatRoute,
  SettingsDefaultModelsRoute: SettingsDefaultModelsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsHotkeysRoute: SettingsHotkeysRoute,
  SettingsKnowledgeBaseRoute: SettingsKnowledgeBaseRoute,
  SettingsMcpRoute: SettingsMcpRoute,
  SettingsWebSearchRoute: SettingsWebSearchRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/copilots': typeof CopilotsRoute
  '/settings/provider': typeof SettingsProviderRouteRouteWithChildren
  '/dev/model-selector': typeof DevModelSelectorRoute
  '/dev/storage': typeof DevStorageRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
  '/settings/chat': typeof SettingsChatRoute
  '/settings/default-models': typeof SettingsDefaultModelsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/hotkeys': typeof SettingsHotkeysRoute
  '/settings/knowledge-base': typeof SettingsKnowledgeBaseRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/web-search': typeof SettingsWebSearchRoute
  '/dev/': typeof DevIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/settings/provider/$providerId': typeof SettingsProviderProviderIdRoute
  '/settings/provider/chatbox-ai': typeof SettingsProviderChatboxAiRoute
  '/settings/provider/': typeof SettingsProviderIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/copilots': typeof CopilotsRoute
  '/dev/model-selector': typeof DevModelSelectorRoute
  '/dev/storage': typeof DevStorageRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
  '/settings/chat': typeof SettingsChatRoute
  '/settings/default-models': typeof SettingsDefaultModelsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/hotkeys': typeof SettingsHotkeysRoute
  '/settings/knowledge-base': typeof SettingsKnowledgeBaseRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/web-search': typeof SettingsWebSearchRoute
  '/dev': typeof DevIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/settings/provider/$providerId': typeof SettingsProviderProviderIdRoute
  '/settings/provider/chatbox-ai': typeof SettingsProviderChatboxAiRoute
  '/settings/provider': typeof SettingsProviderIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dev': typeof DevRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/copilots': typeof CopilotsRoute
  '/settings/provider': typeof SettingsProviderRouteRouteWithChildren
  '/dev/model-selector': typeof DevModelSelectorRoute
  '/dev/storage': typeof DevStorageRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
  '/settings/chat': typeof SettingsChatRoute
  '/settings/default-models': typeof SettingsDefaultModelsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/hotkeys': typeof SettingsHotkeysRoute
  '/settings/knowledge-base': typeof SettingsKnowledgeBaseRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/web-search': typeof SettingsWebSearchRoute
  '/dev/': typeof DevIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/settings/provider/$providerId': typeof SettingsProviderProviderIdRoute
  '/settings/provider/chatbox-ai': typeof SettingsProviderChatboxAiRoute
  '/settings/provider/': typeof SettingsProviderIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dev'
    | '/settings'
    | '/about'
    | '/copilots'
    | '/settings/provider'
    | '/dev/model-selector'
    | '/dev/storage'
    | '/session/$sessionId'
    | '/settings/chat'
    | '/settings/default-models'
    | '/settings/general'
    | '/settings/hotkeys'
    | '/settings/knowledge-base'
    | '/settings/mcp'
    | '/settings/web-search'
    | '/dev/'
    | '/settings/'
    | '/settings/provider/$providerId'
    | '/settings/provider/chatbox-ai'
    | '/settings/provider/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/copilots'
    | '/dev/model-selector'
    | '/dev/storage'
    | '/session/$sessionId'
    | '/settings/chat'
    | '/settings/default-models'
    | '/settings/general'
    | '/settings/hotkeys'
    | '/settings/knowledge-base'
    | '/settings/mcp'
    | '/settings/web-search'
    | '/dev'
    | '/settings'
    | '/settings/provider/$providerId'
    | '/settings/provider/chatbox-ai'
    | '/settings/provider'
  id:
    | '__root__'
    | '/'
    | '/dev'
    | '/settings'
    | '/about'
    | '/copilots'
    | '/settings/provider'
    | '/dev/model-selector'
    | '/dev/storage'
    | '/session/$sessionId'
    | '/settings/chat'
    | '/settings/default-models'
    | '/settings/general'
    | '/settings/hotkeys'
    | '/settings/knowledge-base'
    | '/settings/mcp'
    | '/settings/web-search'
    | '/dev/'
    | '/settings/'
    | '/settings/provider/$providerId'
    | '/settings/provider/chatbox-ai'
    | '/settings/provider/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DevRouteRoute: typeof DevRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  CopilotsRoute: typeof CopilotsRoute
  SessionSessionIdRoute: typeof SessionSessionIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DevRouteRoute: DevRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  CopilotsRoute: CopilotsRoute,
  SessionSessionIdRoute: SessionSessionIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dev",
        "/settings",
        "/about",
        "/copilots",
        "/session/$sessionId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dev": {
      "filePath": "dev/route.tsx",
      "children": [
        "/dev/model-selector",
        "/dev/storage",
        "/dev/"
      ]
    },
    "/settings": {
      "filePath": "settings/route.tsx",
      "children": [
        "/settings/provider",
        "/settings/chat",
        "/settings/default-models",
        "/settings/general",
        "/settings/hotkeys",
        "/settings/knowledge-base",
        "/settings/mcp",
        "/settings/web-search",
        "/settings/"
      ]
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/copilots": {
      "filePath": "copilots.tsx"
    },
    "/settings/provider": {
      "filePath": "settings/provider/route.tsx",
      "parent": "/settings",
      "children": [
        "/settings/provider/$providerId",
        "/settings/provider/chatbox-ai",
        "/settings/provider/"
      ]
    },
    "/dev/model-selector": {
      "filePath": "dev/model-selector.tsx",
      "parent": "/dev"
    },
    "/dev/storage": {
      "filePath": "dev/storage.tsx",
      "parent": "/dev"
    },
    "/session/$sessionId": {
      "filePath": "session/$sessionId.tsx"
    },
    "/settings/chat": {
      "filePath": "settings/chat.tsx",
      "parent": "/settings"
    },
    "/settings/default-models": {
      "filePath": "settings/default-models.tsx",
      "parent": "/settings"
    },
    "/settings/general": {
      "filePath": "settings/general.tsx",
      "parent": "/settings"
    },
    "/settings/hotkeys": {
      "filePath": "settings/hotkeys.tsx",
      "parent": "/settings"
    },
    "/settings/knowledge-base": {
      "filePath": "settings/knowledge-base.tsx",
      "parent": "/settings"
    },
    "/settings/mcp": {
      "filePath": "settings/mcp.tsx",
      "parent": "/settings"
    },
    "/settings/web-search": {
      "filePath": "settings/web-search.tsx",
      "parent": "/settings"
    },
    "/dev/": {
      "filePath": "dev/index.tsx",
      "parent": "/dev"
    },
    "/settings/": {
      "filePath": "settings/index.tsx",
      "parent": "/settings"
    },
    "/settings/provider/$providerId": {
      "filePath": "settings/provider/$providerId.tsx",
      "parent": "/settings/provider"
    },
    "/settings/provider/chatbox-ai": {
      "filePath": "settings/provider/chatbox-ai.tsx",
      "parent": "/settings/provider"
    },
    "/settings/provider/": {
      "filePath": "settings/provider/index.tsx",
      "parent": "/settings/provider"
    }
  }
}
ROUTE_MANIFEST_END */
